const { createMachine } = require("xstate");
const actions = require("./actions");
const guards = require("./guards");
const services = require("./services");

const ListReportsMachine = createMachine(
  {
    /** @xstate-layout N4IgpgJg5mDOIC5QBsCWsAuBaATmADgPY4awB0qEyYAxADIDyAggCIDaADALqKhGyoMqQgDteIAB6IsARgBsZAOwcAnHICsMmSo4AWGeo4yANCACe0mWTmLdKlboDMOuTYAcjvQF8vptJlwCYlIyZEIAQwhUESgaJgBxAFEAOQAVMkZWAElk+IB9RIAlQoZCzh4kEH5BYTFKqQQAJjd1a3dm3Q8ORplFUwsmzTJ1N11dEcUVGTc3Dm6fP3RsPCIScjDI6NiElPScpgBhVKyANUS8liZUpjzMlkT2bnFqoVFxBqxHRTclQzVZuSOdS6RR9czSHpkDhyBxzRSNRTyZrqBYgfzLIJrUIRKIxOJJNJkQ7HM4XK43O4PcrPQgCV51UAfL5WGSNFQtXTQxyObQmcEIVks9SedQaNwyTmNRq6VHowKrEIbXGxamVF61d7STxkLTqHTs7RqPWOfqIZwcazCxrtRQ8npyWVLeXBdY4yA0QqJO6qvi0mpveqWBxkXSA62KQEzOQcWymhDOXTDOSsubQiVueGOgIrF3YyLu71PNV++mahBYfSNHWs7nAxxuOQeYFx0MqMgqRqi3q6a3uaFZjEK135iA0RIADQACqVUj6qiWNYH4zGQ6z2cKYQ54eoW4pWkDwzzuY4e24B86sUr3QBVSeXVLnABCiSYnsKeVSDAA0ik5+qA4ylgcNyIZuNKjSOBB9baHGHhVhwbhqKyIxyE4jjnjml5uqOrAsHkJxMHQ17nJ+eQAGJZHQD5lEWvp0ougHlohVjRohoLWvWzhuHGMhGFWCIcOoorCoJEoOr4aJOphirYR6iQALIMKSBFEecZElPJ5GUdRf4LgBkjSFMbYwr0vEGJ08hggMKZthmcydsBIz2BhmIySONAAMovoUBwABL4YRxF5H5TC5FStHzvR+kNJZSiuIirLfDCGbcfyEp6NY4FCaGdg9DKElytJw4QO6rAEckBwPHkXmvn5ZAHHQ3nhRUdH+gyBnlq4iZTMohjsRGPJxkCba2qGwHKD2OjoQVUmucVpUsOVlV4TVPm+USk6TnQACaulRe1Hy9mQDYqJo7JqI4XVyHGybGfahgtDMPQqC5Q55iVEBkOEADGQgAG60CcWSJAA6nk+xHKc5yetOhSpB5e1tWWFZtlN0I2J2kzjI0PHdImKZJZ4e6jI0r25len0-f9tAeTOiOlkuWCGFW4rOJ2vTfM4ag8Sm7a2noqhOPqZ4zdmc3vZAFAiFTqAAzQQOg3kxJQ3kMMzgjEX-gd0g9mQyINqM3S2JBONpb0rQzM4o0aI0cwyGTWEjlLMty7TcP0wxHVjBap3qLbtqNvCqg8zyZAnqGtrAtoXUO25H1kN9AAWYDfQA1jQHvRVqqghpGYxAiMQKwRGwzcjoBiXSMRix-Nn1Jyn6dsDILWRUjS7aPjMIaBGiEqFxVmIBmCjCuaFdijXZBgDgODEHJqSFLtmt6dr8aimHLggnIbItDCA-xuM1iTEC8L6NGkET2AEgKlsNAQKIYBS39hCpw-l8KheGCZyv3xVgYYHaA2CUPQTRpVEkoUEdg5jAnGMKC+V9gg3ynjPHAZB8DIHCBgAAZsQAAtpPeBJAP5fzLD-Y61oZBAnrB4cUughrRhDCCXiXwYRSi0PlRYYs3pKhvmVUKy1qreTqveCkzB7iPBblrMsCJFDr30MBFwMZERxiZhaCC8gDyGEbJWCe3C8S8IqlVVadU7g5HyEUEoNEJHLzLGdY6KhQQRmjJoBCpsBgjB1CePunRXCqAzLYHwEkRCEBKvASohU5o0n2sjXi4pQLgUgtycUKhlFSirJBex4xQzSgoY2CelBqCRLboxLAtsw5SiNIhG2fc+7KIoYmMC9ippIjEuJDhg5yY4i2IUhmxTERKGoS0Q0ttOTXX5PaVc1pgLe2ApXHR2Fumew+EJC0rMOyaFBKMOMxMylAk5MTCCPQ5lOxdmABZWdyzgT1l8BENZXD2OmLjDQx1UKqD1BKb4oojnx2iCcs5K9OxtmgTMth5kxi41tDqBE7JpTOGca0ySnCOlO3rmnP5Ujh49mlFMXittmjAVggfMCl0YEXUMNNNpH9yBIOIGipc6hQQMN6KMKuwJ4RxilD8BC4xoSIjAnoDscDr4xFpYxREMj7EckbDyXooyBh2BkXYTk+oEIjDAgErwQA */
    predictableActionArguments: true,

    id: "list-reports",

    context: {
      reports: [],
      inactiveReports: [],
      activeReports: [],
      filteredActiveReports: [],
      filteredInactiveReports: [],
      qmsToolApiUrl: undefined,
      authentication: {
        token: undefined,
      },
      loaded_at: undefined,
      activeReportsLoaded: false,
      inactiveReportsLoaded: false,
      view: "active",
      filters: [],
      advancedSearch: {
        year: new Date().getFullYear(),
      },
    },

    states: {
      idle: {
        on: {
          LOAD: {
            target: "loading",
            cond: "validLoadRequest",
            actions: [
              "saveLoadRequest",
              "spawnFetchAgents",
              "saveSearchValue",
              "spawnAdvancedSearchAgent",
            ],
          },
        },
      },

      loading: {
        entry: ["sendLoadRequestToFetchAgents"],

        always: {
          target: "loaded",
          cond: "allDataLoaded",
          actions: [
            "unsetDataLoaded",
            "updateLastRefreshedTimestamp",
            "saveUniqueFiltersOptions",
            "filterActiveReports",
            "filterInactiveReports",
          ],
        },

        on: {
          "AGENT.LOADING_ERROR": {
            target: "error",
            actions: "unsetDataLoaded",
          },

          "AGENT.INACTIVE_DATA_LOADED": {
            target: "loading",
            internal: true,
            actions: ["saveInactiveReports", "setInactiveDataLoaded"],
          },

          "AGENT.ACTIVE_DATA_LOADED": {
            target: "loading",
            internal: true,
            actions: ["saveActiveReports", "setActiveDataLoaded"],
          },

          "ADVANCED_SEARCH.DATA_LOADED": {
            target: "loading",
            internal: true,
            actions: "setAdvancedSearchDataLoaded",
          },

          "ADVANCED_SEARCH.LOADING_ERROR": {
            target: "error",
            actions: "unsetDataLoaded",
          },
        },
      },

      loaded: {
        on: {
          RELOAD: "loading",

          LOAD: {
            target: "loading",
            cond: "validLoadRequest",
            actions: ["saveLoadRequest", "saveSearchValue"],
          },

          EXPORT: {
            target: "exporting",
            actions: "combineAndSortReports",
          },

          UPDATE_BEARER_TOKEN: {
            target: "loaded",
            internal: true,
            cond: "validToken",
            actions: ["saveToken", "sendTokenToFetchAgents"],
          },

          ADD_VALUE_TO_FILTER: {
            target: "loaded",
            internal: true,
            actions: [
              "addValueToFilter",
              "filterActiveReports",
              "filterInactiveReports",
            ],
          },

          REMOVE_VALUE_FROM_FILTER: {
            target: "loaded",
            internal: true,
            actions: [
              "removeValueFromFilter",
              "filterActiveReports",
              "filterInactiveReports",
            ],
          },

          SEARCH_VALUE_CHANGED: {
            target: "loaded",
            internal: true,
            actions: "saveSearchValue",
          },

          "ADVANCED_SEARCH.CLEARED": {
            target: "loading",
            actions: "clearAdvancedSearchOptions",
          },

          "ADVANCED_SEARCH.APPLY": {
            target: "loading",
            actions: "saveAdvancedSearchOptions",
          },
        },

        states: {
          active: {
            on: {
              VIEW_INACTIVE_REPORTS: {
                target: "inactive",
                actions: [
                  "setViewToInactive",
                  "setReportsToFilteredInactiveReports",
                  "sortReports",
                ],
              },

              SORT: {
                target: "active",
                cond: "reportsNotEmpty",
                actions: "sortReports",
                internal: true,
              },
            },
          },

          inactive: {
            on: {
              VIEW_ACTIVE_REPORTS: {
                target: "active",
                actions: [
                  "setViewToActive",
                  "setReportsToFilteredActiveReports",
                  "sortReports",
                ],
              },

              SORT: {
                target: "inactive",
                internal: true,
                cond: "reportsNotEmpty",
                actions: "sortReports",
              },
            },
          },

          check: {
            always: [
              {
                target: "active",
                cond: "activeView",
                actions: [
                  "setViewToActive",
                  "setReportsToFilteredActiveReports",
                  "sortReports",
                ],
              },
              {
                target: "inactive",
                cond: "inactiveView",
                actions: [
                  "setViewToInactive",
                  "setReportsToFilteredInactiveReports",
                  "sortReports",
                ],
              },
            ],
          },
        },

        target: "loaded.active",
        initial: "check",
      },

      error: {
        on: {
          RETRY: "loading",
        },

        entry: "saveError",
      },

      exporting: {
        invoke: {
          src: "exportReports",
          id: "export-report",
          onDone: "loaded",
          onError: "error",
        },
      },
    },

    initial: "idle",
  },
  {
    actions: actions,
    guards: guards,
    services: services,
  },
);

export { ListReportsMachine };
